"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ASSERT: () => ASSERT,
  Array: () => Array2,
  Boolean: () => Boolean,
  Do: () => Do,
  IS_DEV_MODE: () => IS_DEV_MODE,
  IS_JEST: () => IS_JEST,
  LOG: () => LOG,
  Let: () => Let,
  Object: () => _Object,
  bisect: () => bisect,
  brand: () => brand,
  byLessThan: () => byLessThan,
  clamp: () => clamp,
  executable: () => executable,
  findIndex: () => findIndex,
  findLastIndex: () => findLastIndex,
  gcd: () => gcd,
  getIfOwned: () => getIfOwned,
  group: () => group,
  identity: () => identity,
  infer: () => infer,
  lazyConstant: () => lazyConstant,
  lazyPromise: () => lazyPromise,
  many: () => many,
  maybeAssign: () => maybeAssign,
  maybeGet: () => maybeGet,
  mix: () => mix,
  mutable: () => mutable,
  noop: () => noop,
  omit: () => omit,
  rename: () => rename,
  retry: () => retry,
  scale: () => scale,
  setTimeout: () => setTimeout2,
  sleep: () => sleep,
  transform: () => transform,
  ts: () => ts_exports,
  unmix: () => unmix,
  view: () => view,
  visitor: () => visitor,
  when: () => when
});
module.exports = __toCommonJS(src_exports);

// src/Array.ts
var Array2 = globalThis.Array;

// src/maybeGet.ts
var maybeGet = /* @__PURE__ */ __name((target, key) => (
  // @ts-expect-error
  // Type 'K' cannot be used to index type 'T'.ts(2536)
  target?.[key]
), "maybeGet");

// src/ASSERT/get.ts
var get = /* @__PURE__ */ __name((target, key) => ASSERT(maybeGet(target, key)), "get");

// src/ASSERT/ASSERT.ts
var ASSERT = /* @__PURE__ */ __name((condition, elseNotCalled = Error("`utils.ASSERT()` has no error message. Provide one with `.else()`.")) => (Promise.resolve().then(() => {
  if (elseNotCalled) {
    throw elseNotCalled;
  }
}), {
  else: (error) => {
    elseNotCalled = void 0;
    if (!condition) {
      throw typeof error === "function" ? error() : error;
    }
    return condition;
  }
}), "ASSERT");
ASSERT.get = get;

// src/mix.ts
var mix = /* @__PURE__ */ __name((a, b, progress) => a * (1 - progress) + b * progress, "mix");

// src/bisect/continuous.ts
var continuous = /* @__PURE__ */ __name(([a, b], condition = (x) => x >= 0, tolerance = Math.abs(b - a) * 0.01 || Infinity) => {
  if (tolerance < 0) {
    throw Error(`Assumption #2 violated. \`tolerance\` (${tolerance}) was negative.`);
  }
  let [low, high] = [0, 1];
  while ((high - low) * Math.abs(b - a) > tolerance) {
    const middle = (low + high) / 2;
    [low, high] = condition(mix(a, b, middle)) ? [low, middle] : [middle, high];
  }
  return mix(a, b, high);
}, "continuous");

// src/clamp.ts
var clamp = /* @__PURE__ */ __name((x, [low = -Infinity, high = Infinity]) => Math.max(low, Math.min(high, x)), "clamp");

// src/bisect/reverse.ts
var reverse = /* @__PURE__ */ __name((array, condition, [from = 0, until = array.length] = []) => {
  [condition, from, until] = [
    condition instanceof Function ? condition : (x) => x >= condition,
    clamp(from, [0, array.length]),
    clamp(until, [0, array.length])
  ];
  while (from < until) {
    const middle = Math.floor((from + until) / 2);
    [from, until] = condition(array[middle], middle, array) ? [middle, until] : [from, middle - 1];
  }
  return from;
}, "reverse");

// src/bisect/bisect.ts
var bisect = /* @__PURE__ */ __name((array, condition, [from = 0, until = array.length] = []) => {
  [condition, from, until] = [
    condition instanceof Function ? condition : (x) => x >= condition,
    clamp(from, [0, array.length]),
    clamp(until, [0, array.length])
  ];
  while (from < until) {
    const middle = Math.floor((from + until) / 2);
    [from, until] = condition(array[middle], middle, array) ? [from, middle] : [middle + 1, until];
  }
  return from;
}, "bisect");
bisect.continuous = continuous;
bisect.reverse = reverse;

// src/Boolean.ts
var Boolean = globalThis.Boolean;

// src/brand.ts
var brand = /* @__PURE__ */ __name((KEY = Symbol(), VALUE = Math.random()) => ({
  // @ts-expect-error
  // Type 'symbol' is not assignable to type 'unique symbol'.
  KEY,
  check: (x) => maybeGet(x, KEY) === VALUE,
  mark: (x) => Object.assign(x, { [KEY]: VALUE })
}), "brand");

// src/byLessThan.ts
var byLessThan = /* @__PURE__ */ __name((a, b) => a < b ? -1 : b < a ? 1 : 0, "byLessThan");

// src/Do.ts
var Do = /* @__PURE__ */ __name((fn) => ({
  catch: (onRejected) => Do(() => {
    try {
      return fn();
    } catch (reason) {
      return onRejected(reason);
    }
  }),
  done: fn,
  finally: (onFinally) => Do(() => {
    try {
      return fn();
    } finally {
      onFinally();
    }
  }),
  then: (onFulfilled, onRejected) => Do(() => {
    if (onRejected) {
      let result;
      try {
        result = fn();
      } catch (reason) {
        return onRejected(reason);
      }
      return onFulfilled(result);
    } else {
      return onFulfilled(fn());
    }
  })
}), "Do");

// src/lazyConstant.ts
var lazyConstant = /* @__PURE__ */ __name((initialize, value = Symbol.for("UNINITIALIZED"), get2 = Object.assign(() => value === Symbol.for("UNINITIALIZED") ? value = initialize() : value, initialize)) => get2, "lazyConstant");

// src/lazyPromise.ts
var lazyPromise = /* @__PURE__ */ __name((fn, { promise, reject, resolve } = executable(), runOnce = lazyConstant(() => Promise.resolve().then(fn).then(resolve, reject))) => new Proxy(promise, {
  get: (target, property, receiver) => {
    if (property === "catch" || property === "finally" || property === "then") {
      runOnce();
    }
    const result = Reflect.get(target, property, receiver);
    return typeof result === "function" ? result.bind(promise) : result;
  }
}), "lazyPromise");

// src/executable.ts
var executable = /* @__PURE__ */ __name(({ lazy = false } = {}, resolve, reject, result = {
  promise: lazy ? lazyPromise(
    () => new Promise((ok, no) => {
      result.status === "REJECTED" ? no(result.reason) : result.status === "RESOLVED" ? ok(result.value) : [resolve, reject] = [ok, no];
    })
  ) : new Promise((ok, no) => [resolve, reject] = [ok, no]),
  reject: (reason) => {
    if (result.status !== "PENDING") {
      return result;
    }
    reject?.(reason);
    return Object.assign(result, {
      reason,
      status: "REJECTED"
    });
  },
  resolve: (value) => {
    if (result.status !== "PENDING") {
      return result;
    }
    resolve?.(value);
    return Object.assign(result, {
      status: "RESOLVED",
      value
    });
  },
  status: "PENDING"
}) => result, "executable");

// src/findIndex.ts
function findIndex(array, valueOrCondition, from = 0, until = array.length) {
  from = clamp(from, [0, array.length]);
  until = clamp(until, [0, array.length]);
  if (valueOrCondition instanceof Function) {
    const condition = valueOrCondition;
    for (; from < until && !condition(array[from], from, array); ++from)
      ;
  } else {
    const value = valueOrCondition;
    for (; from < until && array[from] !== value; ++from)
      ;
  }
  return from === until ? -1 : from;
}
__name(findIndex, "findIndex");

// src/findLastIndex.ts
function findLastIndex(array, valueOrCondition, from = array.length - 1, until = -1) {
  from = clamp(from, [-1, array.length - 1]);
  until = clamp(until, [-1, array.length - 1]);
  if (valueOrCondition instanceof Function) {
    const condition = valueOrCondition;
    for (; from > until && !condition(array[from], from, array); --from)
      ;
  } else {
    const value = valueOrCondition;
    for (; from > until && array[from] !== value; --from)
      ;
  }
  return from;
}
__name(findLastIndex, "findLastIndex");

// src/gcd.ts
var gcd = /* @__PURE__ */ __name((a, b) => gcd.euclideanAlgorithm(...gcd.normalizeArgs(a, b)), "gcd");
gcd.euclideanAlgorithm = (a, b) => b ? gcd.euclideanAlgorithm(b, a % b) : a;
gcd.normalizeArgs = (a, b) => a < 0 || b < 0 ? (
  // Ignore signs
  [Math.abs(a), Math.abs(b)]
) : !Number.isInteger(a) || !Number.isInteger(b) ? (
  // Round to integers, coerce NaN to 0
  [Math.round(a) || 0, Math.round(b) || 0]
) : a < b ? (
  // Swap arguments so first is same or larger
  [b, a]
) : [a, b];

// src/getIfOwned.ts
var getIfOwned = /* @__PURE__ */ __name((target, key, fallback) => Object.hasOwn(target, key) ? target[key] : fallback, "getIfOwned");

// src/identity.ts
var identity = /* @__PURE__ */ __name((x) => x, "identity");

// src/group.ts
var group = /* @__PURE__ */ __name((array) => ({
  by: (keyFn, valueFn = identity) => array.reduce((groups, x, i) => {
    const key = keyFn(x, i, array);
    {
      const group2 = groups.get(key) ?? groups.set(key, []).get(key);
      const value = valueFn(x, i, array);
      group2.push(value);
    }
    return groups;
  }, /* @__PURE__ */ new Map())
}), "group");

// src/infer.ts
var infer = /* @__PURE__ */ __name(() => ({ from: (value) => value }), "infer");

// src/IS_DEV_MODE.ts
var IS_DEV_MODE = typeof process !== "undefined" && process.env.NODE_ENV === "development";

// src/IS_JEST.ts
var IS_JEST = typeof process !== "undefined" && process.env.JEST_WORKER_ID !== void 0 && // https://stackoverflow.com/questions/50940640/how-to-determine-if-jest-is-running-the-code-or-not#comment114922197_52231746
process.env.NEXT_PHASE === void 0;

// src/Let.ts
var Let = /* @__PURE__ */ __name((key, value, scope = []) => (scope.push([key, value]), {
  // @ts-expect-error
  // A spread argument must either have a tuple type or be passed to a rest parameter.ts(2556)
  get: (by) => by?.(...scope.map(([, value2]) => value2)) ?? Object.entries(scope),
  // @ts-expect-error
  // Expected 2 arguments, but got 3.ts(2554)
  let: (key2, value2) => Let(key2, value2, scope)
}), "Let");

// src/LOG/IF.ts
var IF = /* @__PURE__ */ __name((condition) => (...x) => condition ? LOG(...x) : x[x.length - 1], "IF");

// src/LOG/LOG.ts
var LOG = /* @__PURE__ */ __name((...x) => (console.log(...x), x[x.length - 1]), "LOG");
LOG.IF = IF;

// src/many.ts
var many = /* @__PURE__ */ __name((x) => (
  // @ts-expect-error Generics prevent inference
  Array.isArray(x) ? x : [x]
), "many");

// src/maybeAssign.ts
var maybeAssign = /* @__PURE__ */ __name((target, source) => {
  const sourceEntries = source && typeof source === "object" ? entries(source).filter(([key, value]) => value != null || !hasOwn(target, key)) : [];
  return sourceEntries.length ? assign(target, fromEntries(sourceEntries)) : target;
}, "maybeAssign");
var { assign, entries, fromEntries, hasOwn } = Object;

// src/mutable/Subject.ts
var Subject = /* @__PURE__ */ __name((previous = Symbol()) => {
  const subscribers = [];
  return {
    next: (value) => {
      if (!Object.is(value, previous)) {
        previous = value;
        subscribers.forEach((subscriber) => subscriber?.(value));
      }
    },
    subscribe: (subscriber) => {
      const id = subscribers.push(subscriber) - 1;
      return { unsubscribe: () => subscribers[id] = void 0 };
    }
  };
}, "Subject");

// src/mutable/mutable.ts
var mutable = /* @__PURE__ */ __name((value, set = identity, subject = Subject(), result = Object.assign(() => value, {
  set: (next) => subject.next(value = set(next, result)),
  subscribe: (onChange) => subject.subscribe(onChange).unsubscribe,
  then: (initialValue, set2 = identity) => {
    const next = mutable(initialValue, set2);
    const disconnect = result.subscribe(next.set);
    return Object.assign(next, {
      disconnect,
      upstream: result
    });
  }
})) => result, "mutable");

// src/noop.ts
var noop = /* @__PURE__ */ __name(() => {
}, "noop");

// src/Object.ts
var _Object = globalThis.Object;
_Object.groupBy ??= (items, keySelector) => (Array.isArray(items) ? items : Array.from(items)).reduce((groups, item, index) => {
  (groups[keySelector(item, index)] ??= []).push(item);
  return groups;
}, {});

// src/omit.ts
var omit = /* @__PURE__ */ __name((...[next, ...rest]) => ({
  from: ({ [next]: _, ...target }) => next === void 0 ? target : omit(...rest).from(target)
}), "omit");

// src/rename.ts
var rename = /* @__PURE__ */ __name((name, fn, { overwrite = true } = {}) => overwrite || !fn.name ? defineProperty(fn, "name", {
  configurable: true,
  value: name
}) : fn, "rename");
var { defineProperty } = Object;

// src/sleep.ts
var sleep = /* @__PURE__ */ __name((milliseconds = 0) => new Promise((ok) => setTimeout(ok, milliseconds)), "sleep");

// src/retry.ts
var retry = /* @__PURE__ */ __name((fn, { delay = 1e3, times = 5 } = {}) => Object.assign(async (...args) => {
  try {
    return fn(...args);
  } catch (e) {
    if (times) {
      await sleep(delay);
      return retry(fn, {
        delay,
        times: times - 1
      })(...args);
    } else {
      throw e;
    }
  }
}, fn), "retry");

// src/unmix.ts
var unmix = /* @__PURE__ */ __name((a, b, x) => a === b ? b === x ? 0 : null : (x - a) / (b - a), "unmix");

// src/scale.ts
var scale = /* @__PURE__ */ __name((domain, range, shouldClamp = false) => shouldClamp ? domain[0] <= domain[1] ? (value) => mix(range[0], range[1], unmix(domain[0], domain[1], clamp(value, domain)) ?? 0) : (value) => mix(range[0], range[1], unmix(domain[0], domain[1], clamp(value, [domain[1], domain[0]])) ?? 0) : (value) => mix(range[0], range[1], unmix(domain[0], domain[1], value) ?? 0), "scale");

// src/setTimeout.ts
var setTimeout2 = /* @__PURE__ */ __name((handler, timeout) => {
  if (handler) {
    const id = globalThis.setTimeout(handler, timeout);
    return () => globalThis.clearTimeout(id);
  } else {
    return noop;
  }
}, "setTimeout");

// src/transform/async.ts
var async = /* @__PURE__ */ __name((object) => ({ by: async (fn) => fromEntries2(await fn(entries2(object))) }), "async");
var { entries: entries2, fromEntries: fromEntries2 } = _Object;

// src/transform/transform.ts
var transform = /* @__PURE__ */ __name((object) => ({
  by: _Object.assign(
    (fn) => fromEntries3(fn(entries3(object))),
    // (object-curly-newline)
    { entry: (mapFn) => fromEntries3(entries3(object).map(mapFn).filter(Boolean)) }
  )
}), "transform");
transform.async = async;
var { entries: entries3, fromEntries: fromEntries3 } = _Object;

// src/ts/index.ts
var ts_exports = {};
__export(ts_exports, {
  Tuple: () => Tuple_exports
});

// src/ts/Tuple/index.ts
var Tuple_exports = {};

// src/view.ts
var view = /* @__PURE__ */ __name((target) => ({
  through: (...path) => ({
    read: () => (
      // @ts-expect-error
      // Type 'T' is not assignable to type 'Read<T, O>'.ts(2322)
      path.reduce((target2, key) => target2?.[key], target)
    ),
    write: (setter, [key, ...tail] = path) => (
      // @ts-expect-error
      // Type 'V' is not assignable to type 'Write<T, O, V>'.ts(2322)
      key ? {
        ...target,
        // @ts-expect-error
        // Type '[...O][0]' cannot be used to index type 'T'.ts(2536)
        [key]: view(target[key]).through(...tail).write(setter)
      } : setter(
        // @ts-expect-error
        // Type 'object' is not assignable to type 'Read<T, O>'.ts(2345)
        target
      )
    )
  })
}), "view");

// src/visitor.ts
var visitor = /* @__PURE__ */ __name((actions = {}) => {
  const {
    ARRAY = /* @__PURE__ */ __name((input, _, ...args) => input.map((x, i) => visit(x, i, ...args)), "ARRAY"),
    BIGINT = identity,
    BOOLEAN = identity,
    FUNCTION = identity,
    NULL = identity,
    NUMBER = identity,
    OBJECT = /* @__PURE__ */ __name((input, _, ...args) => transform(input).by((entries4) => entries4.map(([key, value]) => [key, visit(value, key, ...args)])), "OBJECT"),
    STRING = identity,
    SYMBOL = identity,
    UNDEFINED = identity
  } = actions;
  const visit = /* @__PURE__ */ __name((input, key, ...args) => {
    switch (typeof input) {
      case "bigint": {
        return BIGINT(input, key, ...args);
      }
      case "function": {
        return FUNCTION(input, key, ...args);
      }
      case "symbol": {
        return SYMBOL(input, key, ...args);
      }
      case "undefined": {
        return UNDEFINED(input, key, ...args);
      }
      case "boolean": {
        return BOOLEAN(input, key, ...args);
      }
      case "number": {
        return NUMBER(input, key, ...args);
      }
      case "object": {
        return input === null ? NULL(input, key, ...args) : Array.isArray(input) ? ARRAY(input, key, ...args) : OBJECT(input, key, ...args);
      }
      case "string": {
        return STRING(input, key, ...args);
      }
    }
  }, "visit");
  return Object.assign(visit, {
    ARRAY: visit,
    BIGINT: visit,
    BOOLEAN: visit,
    FUNCTION: visit,
    NULL: visit,
    NUMBER: visit,
    OBJECT: visit,
    STRING: visit,
    SYMBOL: visit,
    UNDEFINED: visit
  });
}, "visitor");

// src/when.ts
var when = /* @__PURE__ */ __name((maybe) => ({
  then: (...a) => Object.assign(maybe ? a : [], { else: (...b) => maybe ? a : b })
}), "when");
//# sourceMappingURL=utils.js.map
